import React from 'react'
import { Box } from '@mui/material'
import { muiGrey } from 'src/style/muiTheme'

type Props = {
  isRagDeLion: boolean
  isRagLionLogo: boolean
  logoIndex: number
  logoColorIndex: number
  logoLabel?: string
  logoColorLabel?: string
}

// FIXME いずれこのコンポーネントは削除したい
export const RagLionLogoConfirm: React.FC<Props> = ({ isRagDeLion, isRagLionLogo, logoIndex, logoColorIndex, logoLabel, logoColorLabel }) => {
  const cellColor = (label: string) => (label === '未選択' ? 'red' : muiGrey)
  if (!isRagDeLion) return <></>
  return (
    <Box mb={2}>
      <Box fontWeight="bold" fontSize="16px">
        ライオンロゴ刺繍
      </Box>
      <Box ml={1} key={logoLabel}>
        {`(${logoIndex}) ロゴ：`}
        <Box fontWeight={'bold'} color={cellColor(logoLabel)} component="span">{` ${logoLabel ?? ''}`}</Box>
      </Box>
      {isRagLionLogo && (
        <Box ml={1} key={logoColorLabel}>
          {`(${logoColorIndex}) ${'カラー：'}`}
          <Box fontWeight={'bold'} color={cellColor(logoColorLabel)} component="span">{`${logoColorLabel ?? ''}`}</Box>
        </Box>
      )}
    </Box>
  )
}
